import React from 'react';
import { Link } from 'react-router-dom';
import { GrDocumentPdf } from 'react-icons/gr';
import { IoMdHelpCircle } from 'react-icons/io';
import {
  RiFolderOpenFill,
  RiLineChartFill,
  RiTreasureMapFill,
  RiVideoFill,
} from 'react-icons/ri';

import { checkMot } from '../../ressources/functionJS/checkMot';
import * as url from '../../ressources/glossaires/glossaire_liens_pages';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import styles from './Formation.module.scss';

const Formation = () => {
  const openInNewWindow = (path, width = 1200, height = 750) => {
    window.open(
      path,
      '_blank',
      `toolbar=0,location=0,menubar=0,width=${width},height=${height}`
    );
  };

  return (
    <div className={[s.row, styles.molder].join(' ')}>
      <div className={styles.title}>
        <IoMdHelpCircle size={49} color={'#EEB214'} /> {checkMot('aide')}
        <Link to={url.AideAdmin}>
          <div className={styles.bts}>
            <span className={styles.Span}>/</span>
            {checkMot('admin')}
          </div>
        </Link>
      </div>

      <div className={[s.col_12, styles.img].join(' ')}>
        <h4 className={styles.subtitle}>
          {checkMot('bienvenue_dans_argos_v19')}
        </h4>
        <p className={styles.Parag}>
          {checkMot(
            "Nous sommes ravis de vous compter parmi nous ! consulte le guide l'essentiel pour avoir une vue d'ensemble de tous les aspects de ArgosV19. Consultez  des vidéos pour obtenir d'autres informations."
          )}
        </p>
      </div>

      <div className={[s.col_12, styles.bloc].join(' ')}>
        <h4 className={styles.subtitle}>
          <RiFolderOpenFill size={40} color={'#EEB214'} />{' '}
          {checkMot('demarrage_rapide')}
        </h4>
        <div className={styles.Parag}>
          <div className={styles.icon}>
            <GrDocumentPdf size={20} color={'#a6163f'} />
          </div>
          <button
            type="button"
            onClick={() => openInNewWindow('/pdf/start.pdf')}
            className={styles.lien}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            {checkMot("Guide l'essentiel ")}{' '}
          </button>
          <div> 
          <div className={styles.icon}>
            <GrDocumentPdf size={20} color={'#a6163f'} />
          </div>
          <button
            type="button"
            onClick={() => openInNewWindow('/pdf/start_pt.pdf')}
            className={styles.lien}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            {checkMot('Argos Guia de Utilização')}{' '}
          </button>
          </div>
        </div>
      </div>

      <div className={[s.col_12, styles.bloc].join(' ')}>
        <h4 className={styles.subtitle}>
          <RiLineChartFill size={40} color={'#EEB214'} /> {checkMot('graphes')}
        </h4>
        <div className={styles.Parag}>
          <div className={styles.icon}>
            <RiVideoFill size={30} color={'#a6163f'} />
          </div>
          <button
            type="button"
            className={styles.lien}
            onClick={() => openInNewWindow('/videos/graphe_demo.mp4')}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            {checkMot('affichage_des_graphes')}
          </button>
        </div>
      </div>

      <div className={[s.col_12, styles.bloc].join(' ')}>
        <h4 className={styles.subtitle}>
          <RiTreasureMapFill size={40} color={'#EEB214'} />{' '}
          {checkMot('Vues: Tableaux de bord et Plans')}
        </h4>
        <div className={styles.Parag}>
          <div className={styles.icon}>
            <RiVideoFill size={30} color={'#a6163f'} />
          </div>
          <button
            type="button"
            className={styles.lien}
            onClick={() => openInNewWindow('/videos/vues_demo.mp4', 1000, 750)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            {checkMot('Affichages : Tableaux de bord et Plans')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Formation;
